export default __webpack_public_path__ + "static/media/ellipsis-v-solid.3e8c2ed2.svg";